const state = {
  companyId: null,
  email: null,
  token: null,
  loading: false,
  company: null,
}

const getters = {
  getCompanyId(state) {
    return state.companyId;
  },
  getEmail(state) {
    return state.email;
  },
  getToken(state) {
    return state.token;
  },
  getLoader(state) {
    return state.loading;
  },
  getCompany(state) {
    return state.company;
  }
}

const mutations = {
  setCompanyId(state, id) {
    state.companyId = id;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setToken(state, token) {
    state.token = token;
  },
  setLoader(state, loading) {
    state.loading = loading;
  },
  setCompany(state, company) {
    state.company = company;
  }
}

export default {
  state,
  getters,
  mutations,
}